import React, { useEffect, useRef, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { numberWithCommas } from '../../helpers';
import Spacing from '../Spacing';

export default function AreaChart({encounterAmountPaidMonthWise}) {
  const [chartData, setChartData] = useState({ series: [], options: {} });
  const chartRef = useRef(null);

  useEffect(() => {
    if (encounterAmountPaidMonthWise?.length > 0) {
      const seriesData = encounterAmountPaidMonthWise.map(item => item.total_amount);
      const categoriesData = encounterAmountPaidMonthWise.map(item => item.month_name);
      const yearData = encounterAmountPaidMonthWise.map(item => item.year);
    
      const newOptions = {
        chart: {
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        colors: ['#0E9888'],
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.5,
            opacityTo: 0.7,
            stops: [0, 90, 100],
          },
        },
        xaxis: {
          categories: categoriesData?.map((month) => month?.substring(0, 3)),
          labels: {
            style: {
              colors: '#817F8B',
              fontSize: '12px',
            },
          },
          tooltip: {
            enabled: false,
          },
        },
        yaxis: {
          labels: {
            formatter: function (value) {
              return"$ "+ numberWithCommas(value) ;
            }
          },
        },
        stroke: {
          curve: 'straight',
          width: 2,
        },
        tooltip: {
          x: {
            formatter: function (value, { dataPointIndex }) {
              return categoriesData[dataPointIndex]+' - '+yearData[dataPointIndex];
            },
          },
        },
      };

      const newSeries = [{ data: seriesData, name: 'Payment received' }];

      if (chartRef.current && chartRef.current.chart) {
        chartRef.current.chart.updateOptions(newOptions, false, false);
        chartRef.current.chart.updateSeries(newSeries, false);
      } else {
        setChartData({ series: newSeries, options: newOptions });
      }
    }
  },[encounterAmountPaidMonthWise]);

  return (
    <div className="docpro_chart">
      {encounterAmountPaidMonthWise?.length > 0 ? (
        <ReactApexChart
          ref={chartRef}
          options={chartData?.options}
          series={chartData?.series}
          type="area"
          height={300}
        />
      ) : (
        <Spacing lg="20" sm="20" />
      )}
    </div>
  );
}
